import React from "react";
import { Typography, Card, Space, Flex, Button, List } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined, GithubOutlined, GlobalOutlined, InstagramOutlined, XOutlined } from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

const TermsAndConditions = () => {
    const navigate = useNavigate()
    return (
        <>
            <Flex align="center" gap={10}>
                <ArrowLeftOutlined onClick={() => navigate(-1)} />
                <Text strong style={{ fontSize: "16px" }}>Terms & Conditions</Text>
            </Flex> <br />

            <Card>
                <Space direction="vertical" size="large" style={{ width: "100%" }}>
                    <Text type="secondary">
                        Last updated: {new Date().toLocaleDateString()}
                    </Text>

                    <Paragraph>
                        By accessing or using the Kamuska application, you agree to be bound by
                        these Terms & Conditions.
                    </Paragraph>

                    <Title level={4}>1. Use of the Application</Title>
                    <Paragraph>
                        Kamuska provides a platform for ordering and delivery services. You
                        agree to use the app for lawful purposes only.
                    </Paragraph>

                    <Title level={4}>2. User Responsibilities</Title>
                    <List>
                        <List.Item>Provide accurate and up-to-date information</List.Item>
                        <List.Item>Maintain confidentiality of your account</List.Item>
                        <List.Item>Do not misuse or exploit the platform</List.Item>
                    </List>

                    <Title level={4}>3. Orders & Payments</Title>
                    <Paragraph>
                        Orders are subject to availability. Payments once made are
                        non-refundable unless otherwise specified.
                    </Paragraph>

                    <Title level={4}>4. Delivery</Title>
                    <Paragraph>
                        Delivery times are estimates and may vary due to external factors.
                    </Paragraph>

                    <Title level={4}>5. Account Termination</Title>
                    <Paragraph>
                        We reserve the right to suspend or terminate accounts that violate our
                        policies.
                    </Paragraph>

                    <Title level={4}>6. Limitation of Liability</Title>
                    <Paragraph>
                        Kamuska shall not be liable for indirect or incidental damages arising
                        from use of the application.
                    </Paragraph>

                    <Title level={4}>7. Changes to Terms</Title>
                    <Paragraph>
                        These Terms may be updated at any time. Continued use implies
                        acceptance of the revised terms.
                    </Paragraph>

                    <Title level={4}>8. Contact</Title>
                    <Space>
                        Email: <Link to="mailto:kamuskafoods@gmail.com">kamuskafoods@gmail.com</Link>
                    </Space>
                    <Flex align='center' gap={5}>
                        <Button href="https://instagram.com/kamuska.in"><InstagramOutlined /></Button> &nbsp;
                        <Button href="/"> <GlobalOutlined /> </Button>&nbsp;
                        <Button href="https://github.com/kamuskafoods"> <GithubOutlined /> </Button> &nbsp;
                        <Button href="https://x.com/kamuskafoods"> <XOutlined /> </Button>
                    </Flex>
                </Space>
            </Card>
        </>
    );
};

export default TermsAndConditions;
